// extracted by mini-css-extract-plugin
module.exports = {"facilities--collapsed":"InfoList_facilities--collapsed__eLX4d","facilities--expanded":"InfoList_facilities--expanded__eG0GN"};